
import styled from 'styled-components';


/*

Props:

• marginLeft
• display_mediaQ1

*/

export const StyledDivider = styled.div`

    border-left: 2px solid ${props => (props.color) ? props.color : 'red'};
    height: 35px;
    margin-left: ${props => (props.marginLeft) ? props.marginLeft+'px;' : '0px;'}


`;



// WEBPACK FOOTER //
// ./src/js/components/StyledDivider.jsx